(() => {
  const register = () => {
    Alpine.store('xStoreSelector', {
      enabled: false,
      currentSelected: '',
      appiledAll: false,
      appliedProducts: [],
      appiledCollections: [],
      opened: '',
      selectedStore: localStorage.getItem('selectedStore') || '',
      show: false,
      panelView: 'detail',
      pendingPanelView: 'detail',
      branches: [],
      userLat: null,
      userLng: null,
      pincodeQuery: '',
      pincodeError: false,
      pincodeMessage: '',
      showLocationPrompt: false,
      showSwitchConfirm: false,
      pendingStore: '',
      distances: {},
      filteredBranchKeys: null,
      geolocationPending: false,
      initialized: false,
      sectionId: '',

      // Phase 2 / Option B — additive state (delivery, OOS info, cart validation)
      customerPincode: typeof localStorage !== 'undefined' ? localStorage.getItem('customerPincode') || '' : '',
      // When false: storefront uses global Shopify inventory only (no per-location badges/prompts).
      showLocationInventory: false,
      oosSwitchPromptEnabled: true,
      // Option B default: do not block ATC when OOS at preferred area but in stock elsewhere.
      blockAtcCrossStoreOos: false,
      oosPreferNearest: true,
      enableDeliveryDisplay: false,
      enableCartValidationOnSwitch: true,
      enableSearchStoreFilter: false,
      onlyMyStoreFilter: false,
      showOosSwitchPrompt: false,
      oosPromptContext: null,
      oosAtcBlocked: false,
      currentPickupAvailability: null,
      cartValidationWarnings: [],
      cartValidationLoading: false,
      cartValidationChecked: false,
      cartSplitWarning: false,
      cartSplitWarningLoading: false,
      googleMapsApiKey: '',
      hoursCache: {},
      detailHoursExpanded: false,
      googleMapsScriptPromise: null,

      initStoreSelector(enabled, appiledAll, appliedProducts, appiledCollections, branches, sectionId, enableOosSwitchPrompt, oosPreferNearest, enableDeliveryDisplay, enableCartValidationOnSwitch, enableSearchStoreFilter, googleMapsApiKey, blockAtcCrossStoreOos, showLocationInventory) {
        this.enabled = enabled;
        this.appiledAll = appiledAll;
        this.appliedProducts = appliedProducts;
        this.appiledCollections = appiledCollections;
        this.branches = Array.isArray(branches) ? branches.filter((b) => b.status !== 'inactive') : [];
        this.sectionId = sectionId || '';
        this.showLocationInventory = Boolean(showLocationInventory);
        // Location prompts/badges only when location inventory mode is on.
        this.oosSwitchPromptEnabled = this.showLocationInventory && enableOosSwitchPrompt !== false;
        this.blockAtcCrossStoreOos = this.showLocationInventory && Boolean(blockAtcCrossStoreOos);
        this.oosPreferNearest = oosPreferNearest !== false;
        this.enableDeliveryDisplay = Boolean(enableDeliveryDisplay);
        this.enableCartValidationOnSwitch = this.showLocationInventory && enableCartValidationOnSwitch !== false;
        this.enableSearchStoreFilter = this.showLocationInventory && Boolean(enableSearchStoreFilter);
        this.googleMapsApiKey = googleMapsApiKey || '';
        this.currentSelected = this.selectedStore;
        this.checkSelection(this.branches.map((b) => b.key));
        this.normalizeSelectedStore();
        this.computeDistances();
        this.syncCartAttribute();
        if (this.showLocationInventory) {
          this.refreshCartSplitWarning();
        } else {
          this.cartSplitWarning = false;
          this.oosAtcBlocked = false;
          this.showOosSwitchPrompt = false;
        }
        if (this.googleMapsApiKey) {
          this.branches.forEach((branch) => this.fetchBranchHours(branch));
        }
        if (!this.initialized) {
          this.initialized = true;
          this.handleFirstVisit();
        }
      },

      handleFirstVisit() {
        // Global-inventory mode: do not prompt to pick/switch a store.
        if (!this.enabled || !this.showLocationInventory || this.branches.length === 0) return;
        if (this.selectedStore) {
          this.computeDistances();
          return;
        }
        if (localStorage.getItem('storeSelectorPromptSeen') === 'true') {
          this.open();
          return;
        }
        setTimeout(() => {
          if (!this.selectedStore) this.showLocationPrompt = true;
        }, 800);
      },

      dismissLocationPrompt() {
        this.showLocationPrompt = false;
        localStorage.setItem('storeSelectorPromptSeen', 'true');
      },

      allowLocation() {
        this.dismissLocationPrompt();
        if (!navigator.geolocation) {
          this.open();
          return;
        }
        this.geolocationPending = true;
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            this.geolocationPending = false;
            this.userLat = pos.coords.latitude;
            this.userLng = pos.coords.longitude;
            this.computeDistances();
            const nearest = this.getNearestBranch(this.userLat, this.userLng);
            if (nearest) this.applyStore(nearest.key, true);
          },
          () => {
            this.geolocationPending = false;
            this.open();
          },
          { enableHighAccuracy: false, timeout: 12000, maximumAge: 300000 }
        );
      },

      chooseManually() {
        this.dismissLocationPrompt();
        this.open();
        this.panelView = 'picker';
      },

      haversine(lat1, lon1, lat2, lon2) {
        const toRad = (deg) => (deg * Math.PI) / 180;
        const R = 6371;
        const dLat = toRad(lat2 - lat1);
        const dLon = toRad(lon2 - lon1);
        const a =
          Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
        return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      },

      computeDistances() {
        const refLat = this.userLat;
        const refLng = this.userLng;
        this.distances = {};
        if (refLat == null || refLng == null) return;
        this.branches.forEach((branch) => {
          if (branch.lat && branch.lng) {
            this.distances[branch.key] = this.haversine(refLat, refLng, branch.lat, branch.lng);
          }
        });
      },

      getDistanceText(branchKey) {
        const km = this.distances[branchKey];
        if (km == null) return '';
        if (km < 1) return `${Math.round(km * 10) / 10} KM`;
        return `${Math.round(km)} KM`;
      },

      getNearestBranch(lat, lng) {
        let nearest = null;
        let minDist = Infinity;
        this.branches.forEach((branch) => {
          if (!branch.lat || !branch.lng) return;
          const dist = this.haversine(lat, lng, branch.lat, branch.lng);
          if (dist < minDist) {
            minDist = dist;
            nearest = branch;
          }
        });
        return nearest;
      },

      searchByPincode() {
        const pin = (this.pincodeQuery || '').replace(/\s/g, '');
        this.pincodeError = false;
        this.pincodeMessage = '';
        if (!pin || pin.length < 6) {
          this.pincodeError = true;
          this.filteredBranchKeys = null;
          return;
        }
        const matches = this.branches.filter((branch) => {
          const codes = (branch.servedPincodes || '')
            .split(/[,;\s]+/)
            .map((c) => c.trim())
            .filter(Boolean);
          return codes.some((code) => code === pin || pin.startsWith(code) || code.startsWith(pin));
        });
        if (matches.length === 0) {
          this.pincodeError = true;
          this.filteredBranchKeys = [];
          return;
        }
        this.filteredBranchKeys = matches.map((b) => b.key);
        this.syncPincodeAttribute(pin);
        if (matches.length === 1) {
          this.applyStore(matches[0].key, true, this.sectionId, { keepPanelOpen: true });
        }
      },

      clearPincodeFilter() {
        this.pincodeQuery = '';
        this.pincodeError = false;
        this.pincodeMessage = '';
        this.filteredBranchKeys = null;
      },

      visibleBranches() {
        if (this.filteredBranchKeys === null) return this.branches;
        return this.branches.filter((b) => this.filteredBranchKeys.includes(b.key));
      },

      pickerBranches() {
        return this.visibleBranches();
      },

      sortedPickerBranches() {
        const list = this.pickerBranches();
        if (this.userLat == null || this.userLng == null) return list;
        return [...list].sort((a, b) => {
          const da = this.distances[a.key] ?? Infinity;
          const db = this.distances[b.key] ?? Infinity;
          return da - db;
        });
      },

      ensureUserLocationForPicker() {
        if (this.userLat != null || !navigator.geolocation) return;
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            this.userLat = pos.coords.latitude;
            this.userLng = pos.coords.longitude;
            this.computeDistances();
          },
          () => {},
          { enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 }
        );
      },

      useCurrentLocation() {
        if (!navigator.geolocation) return;
        this.geolocationPending = true;
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            this.geolocationPending = false;
            this.userLat = pos.coords.latitude;
            this.userLng = pos.coords.longitude;
            this.computeDistances();
            const nearest = this.getNearestBranch(this.userLat, this.userLng);
            if (nearest) this.selectBranchFromPicker(nearest.key);
          },
          () => {
            this.geolocationPending = false;
          },
          { enableHighAccuracy: false, timeout: 12000, maximumAge: 300000 }
        );
      },

      getBranchAddressLines(branch) {
        const addr = this.getBranchAddress(branch);
        if (!addr) return { line1: '', line2: '' };
        const parts = addr.split(',').map((p) => p.trim()).filter(Boolean);
        if (parts.length <= 1) return { line1: addr, line2: '' };
        if (parts.length === 2) return { line1: parts[0], line2: parts[1] };
        return { line1: parts.slice(0, 2).join(', '), line2: parts.slice(2).join(', ') };
      },

      formatDistanceAway(branchKey) {
        const km = this.distances[branchKey];
        if (km == null) return '';
        const val = km < 10 ? Math.round(km * 10) / 10 : Math.round(km);
        return `${val} km away`;
      },

      getOpenBadgeLabel(branch) {
        return this.isBranchOpen(branch) ? 'Open' : 'Closed';
      },

      isBranchVisible(branchKey) {
        if (this.filteredBranchKeys === null) return true;
        return this.filteredBranchKeys.includes(branchKey);
      },

      isSelectedBranch(branchKey) {
        return Boolean(branchKey) && this.selectedStore === branchKey;
      },

      getBranchAddress(branch) {
        if (!branch) return '';
        const address = (branch.address || branch.mapQuery || '').trim();
        return address;
      },

      close() {
        this.show = false;
        this.panelView = 'detail';
        if (window.Alpine?.store('xPopup')) {
          Alpine.store('xPopup').close();
        }
      },

      syncPopupOpen() {
        if (!window.Alpine?.store('xPopup')) return;
        const xPopup = Alpine.store('xPopup');
        if (xPopup._closeTimer) {
          clearTimeout(xPopup._closeTimer);
          xPopup._closeTimer = null;
        }
        xPopup.open = true;
      },

      dismissConflictingLayers() {
        this.showOosSwitchPrompt = false;
        this.showSwitchConfirm = false;
        this.showLocationPrompt = false;
        document.querySelectorAll('.x-container-pickup-availability').forEach((el) => {
          const scope = el._x_dataStack?.[0];
          if (scope && 'show' in scope) scope.show = false;
        });
      },

      open() {
        this.normalizeSelectedStore();
        this.dismissConflictingLayers();
        this.show = true;
        if (this.selectedStore) {
          this.currentSelected = this.selectedStore;
          this.panelView = 'detail';
        } else {
          this.panelView = 'picker';
        }
        this.computeDistances();
        this.prefetchVisibleHours();
        if (this.panelView === 'picker') this.ensureUserLocationForPicker();
      },

      openPicker() {
        this.open();
        this.showPicker();
      },

      showPicker() {
        this.show = true;
        this.panelView = 'picker';
        if (this.selectedStore) this.currentSelected = this.selectedStore;
        this.ensureUserLocationForPicker();
        this.prefetchVisibleHours();
      },

      showDetail() {
        this.panelView = 'detail';
        this.detailHoursExpanded = false;
        this.clearPincodeFilter();
        this.prefetchVisibleHours();
      },

      getDetailBranch() {
        const rawKey = this.panelView === 'picker' && this.currentSelected
          ? this.currentSelected
          : this.selectedStore || this.currentSelected;
        return rawKey ? this.resolveBranch(rawKey) : null;
      },

      getMapEmbedUrl(branch) {
        if (!branch) return '';
        const query = branch.mapQuery || branch.address || '';
        if (query) {
          return `https://maps.google.com/maps?q=${encodeURIComponent(query)}&z=15&output=embed`;
        }
        if (branch.lat && branch.lng) {
          return `https://maps.google.com/maps?q=${branch.lat},${branch.lng}&z=15&output=embed`;
        }
        return '';
      },

      getDirectionsUrl(branch) {
        if (!branch) return '#';
        if (branch.mapLink) return branch.mapLink;
        const query = branch.mapQuery || branch.address || '';
        if (query) {
          return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
        }
        if (branch.lat && branch.lng) {
          return `https://www.google.com/maps/search/?api=1&query=${branch.lat},${branch.lng}`;
        }
        return '#';
      },

      loadGoogleMapsScript() {
        if (!this.googleMapsApiKey) {
          return Promise.reject(new Error('Missing Google Maps API key'));
        }
        if (window.google?.maps?.places) {
          return Promise.resolve();
        }
        if (!this.googleMapsScriptPromise) {
          this.googleMapsScriptPromise = new Promise((resolve, reject) => {
            const existing = document.querySelector('script[data-store-selector-google-maps="1"]');
            if (existing) {
              existing.addEventListener('load', () => resolve(), { once: true });
              existing.addEventListener('error', () => reject(new Error('Google Maps failed to load')), { once: true });
              return;
            }
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(this.googleMapsApiKey)}&libraries=places&v=weekly`;
            script.async = true;
            script.defer = true;
            script.dataset.storeSelectorGoogleMaps = '1';
            script.onload = () => resolve();
            script.onerror = () => reject(new Error('Google Maps failed to load'));
            document.head.appendChild(script);
          });
        }
        return this.googleMapsScriptPromise;
      },

      getTodayDayIndex() {
        const jsDay = new Date().getDay();
        return jsDay === 0 ? 6 : jsDay - 1;
      },

      googleTimeToMinutes(timeStr) {
        const t = parseInt(timeStr, 10);
        if (!Number.isFinite(t)) return null;
        const h = Math.floor(t / 100);
        const m = t % 100;
        return h * 60 + m;
      },

      isOpenFromPeriods(periods) {
        if (!periods?.length) return true;
        const now = new Date();
        const currentDay = now.getDay();
        const currentMinutes = now.getHours() * 60 + now.getMinutes();

        for (const period of periods) {
          if (!period.open) continue;
          const openDay = period.open.day;
          const closeDay = period.close?.day ?? openDay;
          const openMin = this.googleTimeToMinutes(period.open.time);
          const closeMin = period.close ? this.googleTimeToMinutes(period.close.time) : 24 * 60;
          if (openMin == null || closeMin == null) continue;

          if (openDay === closeDay) {
            if (currentDay === openDay && currentMinutes >= openMin && currentMinutes < closeMin) return true;
          } else {
            if (currentDay === openDay && currentMinutes >= openMin) return true;
            if (currentDay === closeDay && currentMinutes < closeMin) return true;
          }
        }
        return false;
      },

      getBranchHoursData(branch) {
        if (!branch) return null;
        return this.hoursCache[branch.key] || null;
      },

      async resolvePlaceId(branch) {
        if (!branch) return null;
        if (branch.placeId) return branch.placeId;
        const cached = this.hoursCache[branch.key]?.placeId;
        if (cached) return cached;

        await this.loadGoogleMapsScript();
        const service = new google.maps.places.PlacesService(document.createElement('div'));
        const query =
          branch.mapQuery ||
          branch.address ||
          (branch.lat && branch.lng ? `${branch.lat},${branch.lng}` : '');
        if (!query) return null;

        return new Promise((resolve) => {
          service.findPlaceFromQuery({ query, fields: ['place_id'] }, (results, status) => {
            if (status === google.maps.places.PlacesServiceStatus.OK && results?.[0]?.place_id) {
              resolve(results[0].place_id);
            } else {
              resolve(null);
            }
          });
        });
      },

      async fetchBranchHours(branch) {
        if (!branch || !this.googleMapsApiKey) return null;
        const key = branch.key;
        const cached = this.hoursCache[key];
        if (cached && Date.now() - cached.fetchedAt < 86400000) return cached;

        try {
          await this.loadGoogleMapsScript();
          const placeId = await this.resolvePlaceId(branch);
          if (!placeId) return null;

          const service = new google.maps.places.PlacesService(document.createElement('div'));
          return new Promise((resolve) => {
            service.getDetails({ placeId, fields: ['opening_hours'] }, (place, status) => {
              if (status !== google.maps.places.PlacesServiceStatus.OK || !place?.opening_hours) {
                resolve(null);
                return;
              }
              const opening = place.opening_hours;
              const data = {
                weekdayText: opening.weekday_text || [],
                periods: opening.periods || [],
                openNow: typeof opening.isOpen === 'function' ? opening.isOpen() : Boolean(opening.open_now),
                placeId,
                fetchedAt: Date.now(),
              };
              this.hoursCache = { ...this.hoursCache, [key]: data };
              resolve(data);
            });
          });
        } catch {
          return null;
        }
      },

      prefetchVisibleHours() {
        if (!this.googleMapsApiKey) return;
        const detail = this.getDetailBranch();
        if (detail) this.fetchBranchHours(detail);
        if (this.panelView === 'picker') {
          this.pickerBranches().forEach((branch) => this.fetchBranchHours(branch));
        }
      },

      getTodayHoursLabel(branch) {
        const data = this.getBranchHoursData(branch);
        if (data?.weekdayText?.length) {
          return data.weekdayText[this.getTodayDayIndex()] || '';
        }
        const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const hours = this.formatStoreHoursInline(branch?.hours);
        return hours ? `${dayNames[new Date().getDay()]}: ${hours}` : '';
      },

      getTodayHoursTimes(branch) {
        const label = this.getTodayHoursLabel(branch);
        const match = label.match(/^[^:]+:\s*(.+)$/);
        return match ? match[1].trim() : this.formatStoreHoursInline(branch?.hours);
      },

      getOtherDaysHours(branch) {
        const data = this.getBranchHoursData(branch);
        if (!data?.weekdayText?.length) return [];
        const idx = this.getTodayDayIndex();
        return data.weekdayText.filter((_, i) => i !== idx);
      },

      isBranchOpen(branch) {
        if (!branch) return true;
        const data = this.getBranchHoursData(branch);
        if (data?.periods?.length) {
          return this.isOpenFromPeriods(data.periods);
        }
        if (data && typeof data.openNow === 'boolean') {
          return data.openNow;
        }
        return this.isStoreOpen(branch.hours);
      },

      getStoreStatusLineForBranch(branch) {
        if (!branch) return '';
        const open = this.isBranchOpen(branch);
        const times = String(this.getTodayHoursTimes(branch)).match(/(\d{1,2}(?::\d{2})?\s*(?:AM|PM))/gi);
        if (open && times?.length) {
          return `Open • Closes at ${times[times.length - 1]}`;
        }
        if (!open && times?.length) {
          return `Closed • Opens at ${times[0]}`;
        }
        return open ? 'Open' : 'Closed';
      },

      formatStoreHours(hours) {
        if (!hours) return '';
        return String(hours).replace(/\s*[–—-]\s*/g, '\n');
      },

      formatStoreHoursInline(hours) {
        if (!hours) return '';
        return String(hours).replace(/\s*[–—-]\s*/g, ' - ').trim();
      },

      getBranchLocationTitle(branch) {
        if (!branch) return '';
        const addr = (branch.address || branch.mapQuery || '').trim();
        if (addr) {
          const parts = addr.split(',').map((p) => p.trim()).filter(Boolean);
          if (parts.length >= 2) return `${parts[0]}, ${parts[1]}`;
          return addr;
        }
        return this.getBranchDisplayName(branch);
      },

      getStoreStatusLine(hours) {
        const open = this.isStoreOpen(hours);
        const parts = String(hours || '').match(/(\d{1,2}(?::\d{2})?\s*(?:AM|PM))/gi);
        if (open && parts?.length) {
          return `Open • Closes at ${parts[parts.length - 1]}`;
        }
        if (!open && parts?.length) {
          return `Closed • Opens at ${parts[0]}`;
        }
        return open ? 'Open' : 'Closed';
      },

      getPickupAvailableLabel(branch) {
        if (!branch) return '';
        return `Pickup available at ${this.getBranchDisplayName(branch)}`;
      },

      isStoreOpen(hours) {
        if (!hours) return true;
        const now = new Date();
        const mins = now.getHours() * 60 + now.getMinutes();
        const parts = String(hours).match(/(\d{1,2})(?::(\d{2}))?\s*(AM|PM)/gi);
        if (!parts || parts.length < 2) return true;
        const parse = (token) => {
          const m = token.trim().match(/(\d{1,2})(?::(\d{2}))?\s*(AM|PM)/i);
          if (!m) return null;
          let h = parseInt(m[1], 10);
          const min = parseInt(m[2] || '0', 10);
          const ap = m[3].toUpperCase();
          if (ap === 'PM' && h < 12) h += 12;
          if (ap === 'AM' && h === 12) h = 0;
          return h * 60 + min;
        };
        const open = parse(parts[0]);
        const close = parse(parts[parts.length - 1]);
        if (open == null || close == null) return true;
        return mins >= open && mins <= close;
      },

      selectBranchFromPicker(storeKey) {
        if (!storeKey) return;
        if (this.selectedStore && this.selectedStore !== storeKey) {
          this.pendingStore = storeKey;
          this.pendingPanelView = 'detail';
          this.showSwitchConfirm = true;
          this.runCartValidationForPendingStore();
          return;
        }
        this.applyStore(storeKey, true, this.sectionId, { keepPanelOpen: true });
      },

      setStoreFirst(store, sectionId) {
        if (this.currentSelected === '' && !this.selectedStore) {
          this.currentSelected = store;
        }
        if (sectionId) this.sectionId = sectionId;
      },

      setStore(store) {
        this.currentSelected = store;
      },

      getBranchByKey(key) {
        return this.branches.find((b) => b.key === key);
      },

      decodeStoreKey(key) {
        if (!key) return '';
        return String(key)
          .replace(/&amp;/g, '&')
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&quot;/g, '"');
      },

      // Resolves a persisted key, legacy location name, or partial key to a branch object.
      resolveBranch(keyOrName) {
        if (!keyOrName || !this.branches?.length) return null;
        const decoded = this.decodeStoreKey(keyOrName);
        let branch = this.branches.find((b) => b.key === keyOrName || b.key === decoded);
        if (branch) return branch;
        branch = this.branches.find((b) => b.locationName === keyOrName || b.locationName === decoded);
        if (branch) return branch;
        const suffixMatch = String(decoded).match(/^(.*)-(\d+)$/);
        if (suffixMatch) {
          const locationName = this.decodeStoreKey(suffixMatch[1]);
          branch = this.branches.find((b) => b.locationName === locationName);
          if (branch) return branch;
        }
        return null;
      },

      normalizeSelectedStore() {
        if (!this.selectedStore) return;
        const branch = this.resolveBranch(this.selectedStore);
        if (!branch) return;
        if (this.selectedStore !== branch.key) {
          this.selectedStore = branch.key;
          localStorage.setItem('selectedStore', branch.key);
        }
        this.currentSelected = branch.key;
      },

      getBranchByLocationName(name) {
        return this.findBranchForPickupLocation(name);
      },

      normalizeLocationLabel(name) {
        if (!name) return '';
        return String(name)
          .toLowerCase()
          .replace(/^rathna\s+stores\s*[-–—]\s*/i, '')
          .replace(/\s*\(main\)\s*/gi, ' ')
          .replace(/\bmain\b/gi, '')
          .replace(/[^a-z0-9]/g, '')
          .trim();
      },

      findBranchForPickupLocation(locationName) {
        if (!locationName || !this.branches?.length) return null;
        const direct = this.branches.find((b) => b.locationName === locationName);
        if (direct) return direct;
        const norm = this.normalizeLocationLabel(locationName);
        if (!norm) return null;
        return (
          this.branches.find((b) => {
            const locNorm = this.normalizeLocationLabel(b.locationName);
            const displayNorm = this.normalizeLocationLabel(this.getBranchDisplayName(b));
            return locNorm === norm || displayNorm === norm;
          }) || null
        );
      },

      isSameBranchAsSelected(pickupLocationName) {
        const selectedBranch = this.resolveBranch(this.selectedStore);
        if (!selectedBranch || !pickupLocationName) return false;
        if (pickupLocationName === selectedBranch.locationName) return true;
        const locBranch = this.findBranchForPickupLocation(pickupLocationName);
        return Boolean(locBranch && locBranch.key === selectedBranch.key);
      },

      getSelectedBranch() {
        return this.getBranchByKey(this.selectedStore) || null;
      },

      getStoreClosingLabel() {
        const branch = this.getSelectedBranch();
        if (!branch) return '';
        const times = String(this.getTodayHoursTimes(branch)).match(/\d{1,2}(?::\d{2})?\s*(?:AM|PM|am|pm)/gi);
        if (!times?.length) {
          const parts = String(branch.hours || '').match(/\d{1,2}(?::\d{2})?\s*(?:AM|PM|am|pm)/gi);
          if (!parts?.length) return '';
          return parts[parts.length - 1].replace(/\s/g, '').toUpperCase();
        }
        return times[times.length - 1].replace(/\s/g, '').toUpperCase();
      },

      refreshStoreInventoryUI() {
        if (typeof Alpine === 'undefined' || !Alpine.store('xPickupAvailable')) return;
        Alpine.store('xPickupAvailable').cachedResults = [];
        document.querySelectorAll('[id^="pickup-"]').forEach((el) => {
          const sectionId = el.id.replace(/^pickup-/, '');
          const variantInput = document.querySelector(`#update-variant-${sectionId}, form[data-type="add-to-cart-form"] input[name="id"]`);
          const variantId = variantInput ? variantInput.value : null;
          if (sectionId && variantId) {
            Alpine.store('xPickupAvailable').updatePickUp(sectionId, variantId);
          }
        });
      },

      getStore() {
        const branch = this.resolveBranch(this.selectedStore);
        if (branch) return branch.locationName;
        return '';
      },

      shortenLocationName(name) {
        if (!name) return '';
        const trimmed = String(name).trim();
        const withoutPrefix = trimmed.replace(/^Rathna\s+Stores\s*[-–—]\s*/i, '').trim();
        return withoutPrefix || trimmed;
      },

      getDisplayNameForLocation(locationName) {
        const branch = this.getBranchByLocationName(locationName);
        if (branch) return this.getBranchDisplayName(branch);
        return this.shortenLocationName(locationName);
      },

      getBranchDisplayName(branch) {
        if (!branch) return '';
        const custom = branch.displayName && String(branch.displayName).trim();
        if (custom && custom !== branch.locationName) return custom;
        return this.shortenLocationName(branch.locationName);
      },

      getStoreText() {
        if (!this.selectedStore) return '';
        const branch = this.resolveBranch(this.selectedStore);
        if (branch) return this.getBranchDisplayName(branch);
        return '';
      },

      getStoreKeyByLocationName(locationName) {
        const branch = this.findBranchForPickupLocation(locationName);
        return branch ? branch.key : '';
      },

      checkSelection(storeList) {
        if (!this.selectedStore) return;
        const branch = this.resolveBranch(this.selectedStore);
        if (branch) {
          this.selectedStore = branch.key;
          this.currentSelected = branch.key;
          localStorage.setItem('selectedStore', branch.key);
          return;
        }
        if (this.branches.length > 0) {
          this.selectedStore = this.branches[0].key;
          this.currentSelected = this.branches[0].key;
          localStorage.setItem('selectedStore', this.selectedStore);
        }
      },

      checkAvailability(pickupLocations, pickupAvailabilites) {
        const selectedBranch = this.resolveBranch(this.selectedStore);
        if (!pickupLocations || !pickupAvailabilites) return false;
        if (selectedBranch) {
          for (let i = 0; i < pickupLocations.length; i++) {
            if (!pickupAvailabilites[i]) continue;
            if (this.isSameBranchAsSelected(pickupLocations[i])) return true;
          }
        }
        const store = this.getStore();
        if (store) {
          const idx = pickupLocations.indexOf(store);
          if (idx >= 0) return pickupAvailabilites[idx];
        }
        return false;
      },

      getAvailableAlternatives(pickupLocations, pickupAvailabilites) {
        const selectedName = this.getStore();
        const alternatives = [];
        if (!pickupLocations || !pickupAvailabilites) return alternatives;
        pickupLocations.forEach((loc, i) => {
          if (!pickupAvailabilites[i]) return;
          if (loc === selectedName || this.isSameBranchAsSelected(loc)) return;
          const branch = this.findBranchForPickupLocation(loc);
          const key = branch ? branch.key : this.getStoreKeyByLocationName(loc);
          alternatives.push({
            locationName: loc,
            displayName: branch ? this.getBranchDisplayName(branch) : this.shortenLocationName(loc),
            distance: branch && this.distances[branch.key] != null ? this.distances[branch.key] : null,
            key: key || `${loc}-0`,
          });
        });
        alternatives.sort((a, b) => {
          if (a.distance == null && b.distance == null) return 0;
          if (a.distance == null) return 1;
          if (b.distance == null) return -1;
          return a.distance - b.distance;
        });
        return alternatives;
      },

      formatAlternativeDistance(km) {
        if (km == null) return '';
        if (km < 1) return `${Math.round(km * 10) / 10} KM`;
        return `${Math.round(km)} KM`;
      },

      switchToStore(storeKey) {
        if (!storeKey) return;
        if (this.selectedStore && this.selectedStore !== storeKey) {
          this.pendingStore = storeKey;
          this.showSwitchConfirm = true;
          this.runCartValidationForPendingStore();
          return;
        }
        this.applyStore(storeKey, true);
      },

      confirmSwitch() {
        if (this.pendingStore) {
          const keepOpen = this.show && (this.pendingPanelView === 'detail' || this.panelView === 'picker');
          this.applyStore(this.pendingStore, true, this.sectionId, { keepPanelOpen: keepOpen });
          this.panelView = this.pendingPanelView || 'detail';
          this.pendingStore = '';
          this.pendingPanelView = 'detail';
        }
        this.showSwitchConfirm = false;
        this.cartValidationWarnings = [];
        this.cartValidationChecked = false;
        this.refreshDeliveryEstimate();
      },

      cancelSwitch() {
        this.pendingStore = '';
        this.showSwitchConfirm = false;
        this.cartValidationWarnings = [];
        this.cartValidationChecked = false;
      },

      setSelectedStore(sectionId) {
        if (!this.currentSelected) return;
        if (this.selectedStore && this.selectedStore !== this.currentSelected) {
          this.pendingStore = this.currentSelected;
          this.showSwitchConfirm = true;
          this.runCartValidationForPendingStore();
          return;
        }
        this.applyStore(this.currentSelected, true, sectionId);
      },

      applyStore(storeKey, persist, sectionId, options = {}) {
        if (!storeKey) return;
        this.currentSelected = storeKey;
        this.selectedStore = storeKey;
        localStorage.setItem('selectedStore', storeKey);
        this.clearOosBlockOnStoreChange();
        const sid = sectionId || this.sectionId;
        const el = sid ? document.getElementById('store-selector-name-' + sid) : null;
        if (el) el.textContent = this.getStoreText();
        if (persist) {
          this.syncCartAttribute();
          this.refreshStoreInventoryUI();
          document.dispatchEvent(new CustomEvent('eurus:store:changed', { detail: { store: this.getStore() } }));
        }
        if (options.keepPanelOpen) {
          this.panelView = 'detail';
        } else {
          this.close();
        }
        this.showSwitchConfirm = false;
        this.pendingStore = '';
      },

      // Option B: Preferred_area is a customer area hint for staff — not FO assignment.
      // Store is kept for backward compatibility with existing Admin order views.
      buildCartAreaAttributes() {
        const attributes = {};
        const storeName = this.getStore();
        if (storeName) {
          attributes.Preferred_area = storeName;
          attributes.Store = storeName;
        }
        if (this.customerPincode) attributes.Pincode = this.customerPincode;
        return attributes;
      },

      syncCartAttribute() {
        const attributes = this.buildCartAreaAttributes();
        if (!attributes.Preferred_area || typeof fetch === 'undefined') return;
        const root = typeof Shopify !== 'undefined' && Shopify.routes ? Shopify.routes.root : '/';
        // Shopify's cart/update.js replaces the whole attributes hash, so pincode
        // (if any) must be re-sent to avoid wiping it on area switch.
        fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes }),
        }).catch(() => {});
      },

      // Phase 2 — persists the delivery pincode without clobbering area attributes.
      syncPincodeAttribute(pincode) {
        this.customerPincode = pincode || '';
        if (typeof localStorage !== 'undefined') {
          if (this.customerPincode) {
            localStorage.setItem('customerPincode', this.customerPincode);
          } else {
            localStorage.removeItem('customerPincode');
          }
        }
        if (typeof fetch === 'undefined') return;
        const root = typeof Shopify !== 'undefined' && Shopify.routes ? Shopify.routes.root : '/';
        const attributes = this.buildCartAreaAttributes();
        fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes }),
        }).catch(() => {});
      },

      canShow(productId, collectionIds) {
        if (this.appiledAll) {
          if (this.appliedProducts.length === 0 && this.appiledCollections.length === 0) {
            return true;
          }
          if (this.appliedProducts.includes(Number(productId))) return true;
          for (let i = 0; i < collectionIds.length; i++) {
            if (this.appiledCollections.includes(Number(collectionIds[i]))) return true;
          }
        }
        return false;
      },

      canShowProductPage(productId, collectionIds) {
        if (this.appliedProducts.length === 0 && this.appiledCollections.length === 0) {
          return true;
        }
        if (this.appliedProducts.includes(Number(productId))) return true;
        for (let i = 0; i < collectionIds.length; i++) {
          if (this.appiledCollections.includes(Number(collectionIds[i]))) return true;
        }
        return false;
      },

      // ---------------------------------------------------------------------
      // Phase 2 — Delivery distance/fee helpers (additive; PDP + cart display)
      // ---------------------------------------------------------------------

      getDeliveryDistanceKm(branchKey) {
        const branch = this.getBranchByKey(branchKey);
        if (!branch || !branch.lat || !branch.lng) return null;
        if (this.userLat != null && this.userLng != null) {
          return this.haversine(this.userLat, this.userLng, branch.lat, branch.lng);
        }
        // Option B: pincode-only estimate — if customer pincode is served by this branch,
        // treat as within the free/near tier (0 km) for display until geolocation is available.
        if (this.customerPincode) {
          const pin = String(this.customerPincode).trim();
          const codes = String(branch.servedPincodes || '')
            .split(/[,;\s]+/)
            .map((c) => c.trim())
            .filter(Boolean);
          if (codes.some((code) => code === pin || pin.startsWith(code) || code.startsWith(pin))) {
            return 0;
          }
        }
        return null;
      },

      hasDeliveryConfig(branchKey) {
        const branch = this.getBranchByKey(branchKey);
        if (!branch) return false;
        return (
          branch.freeDeliveryRadiusKm != null ||
          (Array.isArray(branch.deliveryTiers) && branch.deliveryTiers.length > 0) ||
          branch.deliveryTierBeyondFee != null
        );
      },

      getDeliveryCharge(branchKey) {
        const branch = this.getBranchByKey(branchKey);
        if (!branch || !this.hasDeliveryConfig(branchKey)) return null;
        const distanceKm = this.getDeliveryDistanceKm(branchKey);
        if (distanceKm == null) return null;
        if (branch.freeDeliveryRadiusKm != null && distanceKm <= branch.freeDeliveryRadiusKm) {
          return 0;
        }
        const tiers = Array.isArray(branch.deliveryTiers) ? branch.deliveryTiers : [];
        for (let i = 0; i < tiers.length; i++) {
          if (distanceKm <= tiers[i].maxKm) return tiers[i].fee;
        }
        return branch.deliveryTierBeyondFee != null ? branch.deliveryTierBeyondFee : null;
      },

      isDeliveryDisplayEligible(branchKey) {
        if (!this.enabled || !this.enableDeliveryDisplay || !branchKey) return false;
        if (!this.hasDeliveryConfig(branchKey)) return false;
        return this.getDeliveryCharge(branchKey) != null;
      },

      isFreeDelivery(branchKey) {
        return this.getDeliveryCharge(branchKey) === 0;
      },

      getDeliveryChargeText(branchKey, moneyFormat) {
        const fee = this.getDeliveryCharge(branchKey);
        if (fee == null || fee === 0) return '';
        if (typeof Alpine === 'undefined' || !Alpine.store('xHelper')) return '';
        return Alpine.store('xHelper').formatMoney(Math.round(fee * 100), moneyFormat || '{{ amount }}');
      },

      // ---------------------------------------------------------------------
      // Phase 2 — Optional client-side "only available at my store" search filter.
      // Hides result cards client-side only; does not change the Shopify search API results.
      // ---------------------------------------------------------------------

      applySearchStoreFilter(containerId) {
        const container = document.getElementById(containerId || 'items-grid');
        if (!container) return;
        const showAll = !this.enableSearchStoreFilter || !this.onlyMyStoreFilter || !this.selectedStore;
        const storeName = this.getStore();
        container.querySelectorAll('.grid-item[data-pickup-locations]').forEach((el) => {
          if (showAll) {
            el.classList.remove('hidden');
            return;
          }
          let available = true;
          try {
            const locations = JSON.parse(el.dataset.pickupLocations || '[]');
            const availabilites = JSON.parse(el.dataset.pickupAvailabilites || '[]');
            const idx = locations.indexOf(storeName);
            available = idx >= 0 ? Boolean(availabilites[idx]) : locations.length === 0;
          } catch (e) {
            available = true;
          }
          el.classList.toggle('hidden', !available);
        });
      },

      // ---------------------------------------------------------------------
      // Phase 2 — OOS switch prompt (modal + Add to Cart block). Additive to
      // Phase 1 inline messaging in availability-notice.liquid / pickup-availability.liquid,
      // which remain untouched and keep working as a persistent fallback.
      // ---------------------------------------------------------------------

      isOosAtSelectedBranch(pickupLocations, pickupAvailabilites) {
        if (!this.enabled || !this.selectedStore) return false;
        if (!Array.isArray(pickupLocations) || !pickupLocations.length) return false;
        // Unavailable when the branch is missing from pickup locations OR listed but not in stock.
        return !this.checkAvailability(pickupLocations, pickupAvailabilites);
      },

      getOosDismissKey(productId, variantId) {
        return `oosPromptDismissed:${productId}:${variantId}`;
      },

      isOosDismissed(productId, variantId) {
        if (typeof sessionStorage === 'undefined') return false;
        return sessionStorage.getItem(this.getOosDismissKey(productId, variantId)) === 'true';
      },

      markOosDismissed(productId, variantId) {
        if (typeof sessionStorage === 'undefined') return;
        sessionStorage.setItem(this.getOosDismissKey(productId, variantId), 'true');
      },

      shouldPromptOosSwitch(productId, variantId, pickupLocations, pickupAvailabilites) {
        if (!this.oosSwitchPromptEnabled) return false;
        if (!this.isOosAtSelectedBranch(pickupLocations, pickupAvailabilites)) return false;
        if (this.isOosDismissed(productId, variantId)) return false;
        return this.getAvailableAlternatives(pickupLocations, pickupAvailabilites).length > 0;
      },

      canAddToCartForBranch(pickupLocations, pickupAvailabilites) {
        // Option B: never block ATC for cross-store stock unless legacy flag is on.
        if (!this.blockAtcCrossStoreOos) return true;
        if (!this.oosSwitchPromptEnabled) return true;
        if (!this.isOosAtSelectedBranch(pickupLocations, pickupAvailabilites)) return true;
        // OOS everywhere: defer to Shopify's normal sold-out handling.
        return this.getAvailableAlternatives(pickupLocations, pickupAvailabilites).length === 0;
      },

      // Called whenever the pickup-availability section re-renders (initial PDP load,
      // variant change, or after a store switch via refreshStoreInventoryUI).
      maybePromptOnPickupRender(productId, variantId, pickupLocations, pickupAvailabilites) {
        if (!this.enabled || !this.showLocationInventory || productId == null || variantId == null) {
          this.oosAtcBlocked = false;
          return;
        }
        this.currentPickupAvailability = { productId, variantId, pickupLocations, pickupAvailabilites };

        if (!this.oosSwitchPromptEnabled) {
          this.oosAtcBlocked = false;
          return;
        }

        const shouldBlock = this.blockAtcCrossStoreOos && !this.canAddToCartForBranch(pickupLocations, pickupAvailabilites);
        this.oosAtcBlocked = shouldBlock;

        if (this.shouldPromptOosSwitch(productId, variantId, pickupLocations, pickupAvailabilites)) {
          const alternatives = this.getAvailableAlternatives(pickupLocations, pickupAvailabilites);
          this.openOosSwitchPrompt({
            productId,
            variantId,
            alternatives,
            suggestedKey: alternatives[0].key,
            blockAtc: shouldBlock,
          });
          return;
        }

        if (
          this.showOosSwitchPrompt &&
          this.oosPromptContext &&
          String(this.oosPromptContext.productId) === String(productId) &&
          String(this.oosPromptContext.variantId) === String(variantId)
        ) {
          this.showOosSwitchPrompt = false;
          this.oosPromptContext = null;
        }
      },

      openOosSwitchPrompt(context) {
        this.oosPromptContext = context;
        this.showOosSwitchPrompt = true;
        // Only block ATC when legacy cross-store block is enabled.
        this.oosAtcBlocked = Boolean(this.blockAtcCrossStoreOos && context && context.blockAtc !== false);
      },

      // Invoked from product-cart.js when Add to Cart is clicked on a blocked variant.
      openOosSwitchPromptFromAtc(variantId) {
        const ctx = this.currentPickupAvailability;
        if (!ctx || String(ctx.variantId) !== String(variantId)) return;
        const alternatives = this.getAvailableAlternatives(ctx.pickupLocations, ctx.pickupAvailabilites);
        if (!alternatives.length) return;
        this.openOosSwitchPrompt({
          productId: ctx.productId,
          variantId: ctx.variantId,
          alternatives,
          suggestedKey: alternatives[0].key,
          blockAtc: true,
        });
      },

      shouldBlockAtcForCurrentVariant(variantId) {
        if (!this.blockAtcCrossStoreOos || !this.oosSwitchPromptEnabled || variantId == null) return false;
        const ctx = this.currentPickupAvailability;
        if (!ctx || String(ctx.variantId) !== String(variantId)) return false;
        return !this.canAddToCartForBranch(ctx.pickupLocations, ctx.pickupAvailabilites);
      },

      getOosSuggestedBranch() {
        return (this.oosPromptContext && this.oosPromptContext.alternatives && this.oosPromptContext.alternatives[0]) || null;
      },

      getOosSuggestedBranchName() {
        const alt = this.getOosSuggestedBranch();
        return alt ? alt.displayName : '';
      },

      getOosSuggestedBranchText() {
        const alt = this.getOosSuggestedBranch();
        if (!alt) return '';
        return alt.distance != null ? `${alt.displayName} (${this.formatAlternativeDistance(alt.distance)})` : alt.displayName;
      },

      confirmOosSwitch() {
        if (this.oosPromptContext && this.oosPromptContext.suggestedKey) {
          this.applyStore(this.oosPromptContext.suggestedKey, true, this.sectionId, { keepPanelOpen: false });
        }
        this.showOosSwitchPrompt = false;
        this.oosPromptContext = null;
        this.oosAtcBlocked = false;
      },

      dismissOosSwitch() {
        if (this.oosPromptContext) {
          this.markOosDismissed(this.oosPromptContext.productId, this.oosPromptContext.variantId);
        }
        this.showOosSwitchPrompt = false;
        this.oosAtcBlocked = false;
      },

      clearOosBlockOnStoreChange() {
        this.oosAtcBlocked = false;
        this.showOosSwitchPrompt = false;
        this.oosPromptContext = null;
      },

      // ---------------------------------------------------------------------
      // Phase 2 — Cart validation on store switch (warn-only, never auto-removes items)
      // ---------------------------------------------------------------------

      // Delivery figures are computed live off selectedStore/userLat/userLng, so this simply
      // re-runs the distance calc in case geolocation changed since the branch was last loaded.
      refreshDeliveryEstimate() {
        this.computeDistances();
      },

      // Option B — soft cart note when some lines are OOS at preferred area but stocked elsewhere.
      async refreshCartSplitWarning() {
        if (!this.enabled || !this.showLocationInventory || typeof fetch === 'undefined') {
          this.cartSplitWarning = false;
          return;
        }
        if (!this.selectedStore) {
          this.cartSplitWarning = false;
          return;
        }
        this.cartSplitWarningLoading = true;
        try {
          const warnings = await this.validateCartForStore(this.selectedStore);
          // Lines unavailable at preferred area may still ship from another branch → possible split.
          this.cartSplitWarning = Array.isArray(warnings) && warnings.length > 0;
        } catch (e) {
          this.cartSplitWarning = false;
        }
        this.cartSplitWarningLoading = false;
      },

      runCartValidationForPendingStore() {
        this.cartValidationWarnings = [];
        this.cartValidationChecked = false;
        if (!this.enableCartValidationOnSwitch || !this.pendingStore) return;
        this.cartValidationLoading = true;
        const requestedFor = this.pendingStore;
        this.validateCartForStore(requestedFor).then((warnings) => {
          // Ignore stale responses if the user picked a different branch while this was in flight.
          if (this.pendingStore !== requestedFor) return;
          this.cartValidationWarnings = warnings;
          this.cartValidationChecked = true;
          this.cartValidationLoading = false;
        });
      },

      async validateCartForStore(storeKey) {
        if (typeof fetch === 'undefined') return [];
        const targetBranch = this.getBranchByKey(storeKey);
        if (!targetBranch) return [];
        try {
          const root = typeof Shopify !== 'undefined' && Shopify.routes ? Shopify.routes.root : '/';
          const cartResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
          const cart = await cartResponse.json();
          if (!cart || !Array.isArray(cart.items) || !cart.items.length) return [];

          const results = await Promise.all(
            cart.items.map(async (item) => {
              try {
                const link = root + `variants/${item.variant_id}/?section_id=pickup-availability`;
                const res = await fetch(link);
                const text = await res.text();
                const doc = new DOMParser().parseFromString(text, 'text/html');
                const dataEl = doc.querySelector('.x-pickup-availability-payload');
                if (!dataEl) return null;
                const payload = JSON.parse(dataEl.textContent);
                const locations = payload.pickupLocations || [];
                const availabilites = payload.pickupAvailabilites || [];
                let available = null;
                for (let i = 0; i < locations.length; i++) {
                  if (this.normalizeLocationLabel(locations[i]) === this.normalizeLocationLabel(targetBranch.locationName)) {
                    available = Boolean(availabilites[i]);
                    break;
                  }
                }
                if (available === false) {
                  return { title: item.product_title, variantId: item.variant_id };
                }
                return null;
              } catch (e) {
                return null;
              }
            })
          );

          return results.filter(Boolean);
        } catch (e) {
          return [];
        }
      },
    });
  };
  if (window.Alpine) {
    register();
  } else {
    document.addEventListener('alpine:init', register);
  }

  // Keep search filter + cart split warning in sync after an area switch.
  document.addEventListener('eurus:store:changed', () => {
    const selector = window.Alpine && Alpine.store('xStoreSelector');
    if (!selector) return;
    if (selector.onlyMyStoreFilter) {
      selector.applySearchStoreFilter('items-grid');
    }
    selector.refreshCartSplitWarning();
  });

  document.addEventListener('eurus:cart:items-changed', () => {
    if (window.Alpine && Alpine.store('xStoreSelector')) {
      Alpine.store('xStoreSelector').refreshCartSplitWarning();
    }
  });
})();
